<template>
  <div class="wrapper">
    <div data-color="black" data-image="#" class="sidebar">
      <div class="sidebar-wrapper">
        <div class="logo">
          <a href="#" class="justify-content-center simple-text logo__container">
            Connector
          </a>
        </div>
          <ul class="nav">
            <li class="nav-item active cursorPointer">
              <a href="/admin" class="nav-link">
              <i class="nc-icon nc-circle-09"></i>
                <p>Home</p></a>
            </li>
            <li class="nav-item">
              <a @click="realizarLgoff" class="nav-link cursorPointer">
                <i class="nc-icon nc-circle-09"></i>
                <p>Finalizar Sessão</p></a>
            </li>
          </ul>
      </div>
    </div>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar"> </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu.vue";
import Swal from 'sweetalert2';
import { Datas } from '../lib/Helper/index';

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    realizarLgoff() {
      localStorage.setItem("senhaUsuario", "");
      localStorage.setItem("nomeUsuario", "");
      localStorage.setItem("nomeCliente", "");
      localStorage.setItem("tokenAPI", "");
      localStorage.setItem("tokenExpira", "");
      this.$router.push(`/${this.$route.params.nomeCliente}`);
    },
  },
  created() {
    if (
      !localStorage.getItem("senhaUsuario") ||
      !localStorage.getItem("nomeUsuario") ||
      !localStorage.getItem("nomeCliente")
    ) {
       Swal.fire({
          title: 'Ops...',
          text: `Login expirado, realize o acesso novamente!.`,
          icon: 'warning',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
      if (!this.$route.params.nomeCliente) {
        this.$router.push(`/`);
      } else {
        this.$router.push(`/${this.$route.params.nomeCliente}`);
      }
    }else{
      if(localStorage.getItem("tokenExpira")){
        const expirado = Datas.ValidarTempoExirado(localStorage.getItem("tokenExpira"), new Date());
        if(expirado <= 1.99){
          Swal.fire({
            title: 'Ops...',
            text: `Login expirado, realize o acesso novamente!.`,
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          });
          this.realizarLgoff();
        }
      }
    }
  },
};
</script>
